import { Link, useParams } from 'react-router-dom';

import styles from '../../css/admin/SettlementStatement.module.css';
import statusStyles from '../../css/admin/Status.module.css';
import useAdminProfile from '../../hooks/useAdminProfile';
import { isApp } from '../../utils/isApp'; // [APP-FORK]
import StatusTabs from '../admin/StatusTabs';
import {
  MESSAGES,
  buildSaleMonths,
  formatMonthDot,
  mobileListPath,
  statementTitle,
  toPayoutMonth,
} from './settlementStatement.util';

/**
 * 정산명세서 목록(/mobile/:storeNo/settlement).
 * 월 목록은 프론트에서 만들고, 로그인·점주 여부는 GET profile로 확인한다.
 */
export default function SettlementListMobile() {
  const { storeNo } = useParams();
  const { loading, profile, isOwner, status } = useAdminProfile();
  const months = buildSaleMonths();

  const renderBody = () => {
    if (loading) return <p className={styles.message}>{MESSAGES.loading}</p>;
    if (!profile) {
      return status === 401 ? null : <p className={styles.message}>{MESSAGES.error}</p>;
    }
    if (!isOwner) return <p className={styles.message}>{MESSAGES.forbidden}</p>;
    if (months.length === 0) return <p className={styles.message}>{MESSAGES.empty}</p>;
    return (
      <ul className={styles.list}>
        {months.map(month => (
          <li key={month}>
            <Link
              className={styles.listItem}
              to={`${mobileListPath(storeNo)}/${toPayoutMonth(month)}`}
              state={{ fromList: true }}
            >
              <span className={styles.listText}>
                <span className={styles.listTitle}>{statementTitle(month)}</span>
                <span className={styles.listSub}>이용기간 {formatMonthDot(month)}</span>
              </span>
              <span className={styles.chevron} aria-hidden="true">›</span>
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div
      className={
        isApp() ? `${statusStyles.page} ${statusStyles.pageApp}` : statusStyles.page
      }
    >
      {profile && (
        <StatusTabs storeNo={storeNo} activeTab="settlement" showSettlement={isOwner} />
      )}
      <section className={statusStyles.section}>{renderBody()}</section>
    </div>
  );
}
